import ResponsiveSidebar from "../../General/ResponsiveSidebar/ResponsiveSidebar";
import React from "react";
import {
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Toolbar,
  IconButton,
  Tooltip,
} from "@mui/material";
import {
  Menu as MenuIcon,
  ChevronLeft as ChevronLeftIcon,
  History as HistoryIcon,
} from "@mui/icons-material";
import { Link as RouterLink, useLocation } from "react-router-dom";

const drawerWidth = 240;
const collapsedWidth = 60;

interface SidebarProps {
  open?: boolean;
  toggle?: () => void;
}

const LogsSidebar = ({ open = false, toggle = () => {} }: SidebarProps) => {
  const location = useLocation();

  const isSelected = (path: string) => location.pathname.startsWith(path);

  return (
    <>
      <ResponsiveSidebar
        open={open}
        onClose={toggle}
        sx={(theme) => ({
          width: open ? drawerWidth : collapsedWidth,
          flexShrink: 0,
          "& .MuiDrawer-paper": {
            width: open ? drawerWidth : collapsedWidth,
            boxSizing: "border-box",
            top: 64,
            height: "calc(100% - 64px)",
            overflowX: "hidden",
            position: "fixed",
            transition: theme.transitions.create("width", {
              duration: theme.transitions.duration.standard,
            }),
          },
        })}
      >
        <Toolbar sx={{ justifyContent: open ? "flex-end" : "center" }}>
          <IconButton
            onClick={toggle}
            aria-label={
              open ? "Close section navigation" : "Open section navigation"
            }
          >
            {open ? <ChevronLeftIcon /> : <MenuIcon />}
          </IconButton>
        </Toolbar>
        <List>
          {open ? (
            <ListItemButton
              selected={isSelected("/logs")}
              component={RouterLink}
              to="/logs"
              sx={{ justifyContent: "initial" }}
            >
              <ListItemIcon
                sx={{
                  minWidth: 0,
                  mr: 3,
                  justifyContent: "center",
                }}
              >
                <HistoryIcon />
              </ListItemIcon>
              <ListItemText primary="Logs" sx={{ opacity: 1 }} />
            </ListItemButton>
          ) : (
            <Tooltip title="Logs" placement="right">
              <ListItemButton
                selected={isSelected("/logs")}
                component={RouterLink}
                to="/logs"
                sx={{ justifyContent: "center" }}
              >
                <ListItemIcon
                  sx={{
                    minWidth: 0,
                    mr: 0,
                    justifyContent: "center",
                  }}
                >
                  <HistoryIcon />
                </ListItemIcon>
              </ListItemButton>
            </Tooltip>
          )}
        </List>
      </ResponsiveSidebar>
    </>
  );
};

export default LogsSidebar;
